import React, { useEffect, useState } from "react";
import DynamicTable from "@atlaskit/dynamic-table";
import Pagination from "@atlaskit/pagination";
import SearchIcon from "@atlaskit/icon/glyph/search";
import ChevronLeftIcon from "@atlaskit/icon/glyph/chevron-left";
import ChevronRightLargeIcon from "@atlaskit/icon/glyph/chevron-right-large";
import ChevronLeftLargeIcon from "@atlaskit/icon/glyph/chevron-left-large";
import ArrowDownIcon from "@atlaskit/icon/glyph/arrow-down";
import ExcelSpreadsheet16Icon from "@atlaskit/icon-file-type/glyph/excel-spreadsheet/16";
import Document16Icon from "@atlaskit/icon-file-type/glyph/document/16";
import Button, { ButtonGroup } from "@atlaskit/button";
import {
  TableWrapper,
  createCells,
  createHead,
} from "../TableConfig/WrapperRestoreConfig";
import BitbucketCloneIcon from "@atlaskit/icon/glyph/bitbucket/clone";
import ProgressTrack from "../../../components/Shared/ProgressTracker/ProgressTrack";
import Popup from "@atlaskit/popup";
// import Textfield from "@atlaskit/textfield";
// import Form, { Field, ErrorMessage } from "@atlaskit/form";

import styles from "./RestorePreviewConfig.module.css";

import { pageSize } from "../../../constants/constants";

const RestorePreviewConfig = (props) => {
  const [totalPages, setTotalPages] = useState(0);
  const [newFilterData, setNewFilterData] = useState(props.filterData);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const setData = async () => {
      setTotalPages(Math.ceil(props.snapshotCount / pageSize));
    };
    setData();
  }, [props.snapshotCount, props.pageData.pagination, props.pageNumber]);

  const rows = createCells(
    props.previewData,
    props.handleCheckboxCheckConfig,
    props.tempCheckedItems,
    props.checkedIssues
  );
  const head = createHead(
    true,
    props.handleCheckboxCheckAllConfig,
    props.isLoading,
    props.globalCheckState
  );

  return (
    <div className={styles.mainContainer}>
      <div className={styles.tracker}>
        <div className={styles.trackerItem}>
          <ProgressTrack data={props.progressTrack} />
        </div>
      </div>
      <hr />
      <div className={styles.container}>
        {/* <Form
          onSubmit={(data) => {
            props.handleMapField(newFilterData);
          }}
          isDisabled={props.isLoading}
        >
          {({ formProps }) => (
            <form {...formProps}>
              <div className={styles.infoContainer}>
                <div className={styles.infoItem}>
                  <Field
                    name="searchText"
                    defaultValue={props.formStateData.searchText}
                    validate={async (value) => {
                      const regexp = new RegExp("^[ A-Za-z0-9@#_-]*$");
                      if (regexp.test(value)) {
                        return undefined;
                      } else {
                        return "Please Enter A Vaid Name";
                      }
                    }}
                  >
                    {({ fieldProps, error }) => (
                      <>
                        <Textfield
                          elemAfterInput={
                            <div
                              style={{
                                paddingRight: "6px",
                                lineHeight: "100%",
                              }}
                            >
                              <SearchIcon
                                size="small"
                                borderColor="transparent"
                              />
                            </div>
                          }
                          placeholder="Search "
                          {...fieldProps}
                          onChange={(value) => {
                            props.setFormStateData({
                              ...props.formStateData,
                              searchText: value.target.value,
                            });
                            setNewFilterData({
                              ...newFilterData,
                              searchText: value.target.value,
                            });
                            fieldProps.onChange(value);
                          }}
                        />
                        {error && <ErrorMessage>{error}</ErrorMessage>}
                      </>
                    )}
                  </Field>
                </div>
              </div>
            </form>
          )}
        </Form> */}

        <div className={styles.infoContainer}>
          <div className={styles.infoItem}>
            <strong>
              {props.filterData.configType === "screens"
                ? `Selected screens : ${props.checkedIssues.length}`
                : props.filterData.configType === "workflows"
                ? `Selected workflows: ${props.checkedIssues.length}`
                : ""}
            </strong>{" "}
          </div>
        </div>
      </div>
      <div className={styles.tableContainer}>
        <TableWrapper>
          <DynamicTable
            head={head}
            rows={rows}
            rowsPerPage={undefined}
            defaultPage={1}
            loadingSpinnerSize="large"
            isLoading={props.isLoading}
            isFixedSize
            emptyView={<strong>No data found</strong>}
          />
        </TableWrapper>

        {props.pageData.pagination.nextToken === null &&
        props.pageNumber === 1 ? (
          ""
        ) : (
          <div style={{ gap: "20px" }}>
            <Button
              iconBefore={<ChevronLeftLargeIcon label="Back" size="medium" />}
              appearance="default"
              id="prevPage"
              onClick={props.getPrevData}
              isDisabled={props.isLoading || props.pageNumber === 1}
            ></Button>
            {props.pageNumber}
            <Button
              iconBefore={<ChevronRightLargeIcon label="Back" size="medium" />}
              appearance="default"
              id="nextPage"
              onClick={props.getNextData}
              isDisabled={
                props.isLoading || props.pageData.pagination.nextToken === null
              }
            ></Button>
          </div>
        )}
        <div className={styles.buttons}>
          <ButtonGroup className={styles.buttons}>
            <Button
              iconBefore={<ChevronLeftIcon label="Back" size="medium" />}
              appearance="default"
              id="backPreviewData"
              onClick={props.handlePreviewConfigBack}
              isDisabled={props.isLoading}
            >
              Back
            </Button>

            <Popup
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
              placement="bottom-start"
              content={() => (
                <div className={styles.content}>
                  <ButtonGroup appearance="subtle">
                    <Button
                      spacing="compact"
                      iconBefore={<Document16Icon label="Download JSON" />}
                      onClick={() => {
                        props.setDownloadType("json")
                        props.setShowDownloadConfirm(true)
                        // props.handleDownloadData("json");
                        setIsOpen(false);
                      }}
                    >
                      JSON
                    </Button>
                    <Button
                      spacing="compact"
                      iconBefore={
                        <ExcelSpreadsheet16Icon label="Download CSV" />
                      }
                      onClick={() => {
                        props.setDownloadType("csv")
                        props.setShowDownloadConfirm(true)
                        // props.handleDownloadData("csv");
                        setIsOpen(false);
                      }}
                    >
                      CSV
                    </Button>
                  </ButtonGroup>
                </div>
              )}
              trigger={(triggerProps) => (
                <Button
                  {...triggerProps}
                  iconBefore={
                    <ArrowDownIcon
                      label="Restore Configuration"
                      size="medium"
                    />
                  }
                  appearance="default"
                  isSelected={isOpen}
                  isDisabled={
                    props.isLoading || props.checkedIssues.length === 0
                  }
                  onClick={() => setIsOpen(!isOpen)}
                >
                  Download Data
                </Button>
              )}
            />
            <Button
              iconBefore={
                <BitbucketCloneIcon label="Restore Issues" size="medium" />
              }
              appearance="primary"
              id="restore"
              onClick={()=>props.setShowConfirmation(true)}
              isDisabled={
                props.isLoading ||
                props.checkedIssues.length === 0 ||
                props.checkedIssues.length > 50
              }
            >
              Restore
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </div>
  );
};

export default RestorePreviewConfig;
